import axios from "axios";
import { API_BASE_URL1, API_BASE_URL3 } from "../Services/baseApiUrl";
import { CleaningServices } from "@mui/icons-material";
import axiosInstance from "../../Hooks/axoisInstance";

const getToken = () => {
  return localStorage.getItem("token");
};

export const getAllZoneWiseReport = async (requestData) => {
  try {
    const { Date, VehicleTypeId, ownerType, vehicleId, transferStationId } =
      requestData;
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `SATReport/SATZoneWiseDetailsReport?Date=${Date}&VehicleTypeId=${VehicleTypeId}&OwnerTypeId=${ownerType}&VehicleNumber=${vehicleId}&TransferStationId=${transferStationId}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAllCircleWiseReport = async (requestData) => {
  try {
    const {
      Date,
      VehicleTypeId,
      ownerType,
      vehicleId,
      transferStationId,
      ZoneIds,
    } = requestData;
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `SATReport/SATCircleWiseDetailsReport?Date=${Date}&VehicleTypeId=${VehicleTypeId}&OwnerTypeId=${ownerType}&VehicleNumber=${vehicleId}&TransferStationId=${transferStationId}&ZoneIds=`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// export const getAllCircleWiseReport = async (requestData) => {
//     try {
//         const { Date, VehicleTypeId,ownerType,vehicleId,transferStationId,...rest } = requestData;
//         const token = getToken();

//     const queryString = new URLSearchParams({ Date, VehicleTypeId,ownerType,vehicleId,transferStationId, ...rest }).toString();
//     const url = `${API_BASE_URL1}SATReport/SATCircleWiseDetailsReport?${queryString}`;

//     const response = await axiosInstance.get(url, {
//       headers: {
//         'Content-Type': 'application/json',
//         Authorization: `Bearer ${token}`
//       }
//   });
//         return response;
//     } catch (error) {
//         throw error
//     }
// };

//  export const innergetAllZoneWiseReport = async (requestData) => {
//     try {
//         const { date, VehicleTypeId, ZoneId } = requestData;
//         const response = await axios.get(`${API_BASE_URL1}SATReport/SATCircleWiseDetailsReport`, {
//             params: {
//                 Date: date,
//                 VehicleTypeId: VehicleTypeId,
//                 ZoneId: ZoneId
//             },
//             headers: {
//                 Authorization: `Bearer ${getToken()}`
//             }
//         });
//         return response;
//     } catch (error) {
//         throw error;
//     }
// };

// export const innergetAllZoneWiseReport = async (requestData) => {
//   try {
//     const {Date,ZoneId,VehicleTypeId}=requestData
//     const response = await axiosInstance.get(API_BASE_URL1 + `SATReport/SATCircleWiseDetailsReport?Date=${Date}&ZoneId=${ZoneId}&vehicleTypeId=${VehicleTypeId}`,
//     {
//       headers:{
//         Authorization: `Bearer ${getToken()}`
//       }
//     }
//     );
//     return response.data;
//   } catch (error) {
//     throw error;

//   }
// };

export const innergetAllZoneWiseReport = async (requestData) => {
  try {
    const {
      ZoneIds,
      Date,
      VehicleTypeId,
      ownerType,
      vehicleId,
      transferStationId,
      vehicleNumber,
    } = requestData;

    const queryParams = {
      Date,
      ZoneIds,
      vehicleTypeId: VehicleTypeId,
    };

    if (ownerType) queryParams.ownerType = ownerType;
    if (vehicleId) queryParams.vehicleId = vehicleId;
    if (transferStationId) queryParams.transferStationId = transferStationId;
    if (vehicleNumber) queryParams.vehicleNumber = vehicleNumber;

    const queryString = new URLSearchParams(queryParams).toString();
    const url = `${API_BASE_URL1}SATReport/SATCircleWiseDetailsReport?${queryString}`;

    const response = await axiosInstance.get(url, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

//   export const innergetAllZoneWiseReport = async (requestData) => {
//     try {
//         const { Date, VehicleTypeId,ZoneId,...rest } = requestData;
//         const token = getToken();

//         const queryString = new URLSearchParams({ Date,VehicleTypeId,ZoneId, ...rest }).toString();
//         const url = `${API_BASE_URL1}SATReport/SATCircleWiseDetailsReport?${queryString}`;

//         const response = await axios.get(url, {
//           headers: {
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${token}`
//           }
//       });
//         return response;
//     } catch (error) {
//         throw error
//     }
// };

export const AllVehicleDetailsByCollectionTypeId = async (requestData) => {
  try {
    const { CollectionTypeId } = requestData;
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `MasterDetails/GetAllVehicleTypeByCollectionType?CollectionTypeId=${CollectionTypeId}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const innergetVehicleReport = async (requestData) => {
  try {
    const {
      VehicleTypeId,
      ZoneId,
      VehicleStatusId,
      CollectionTypeId,
      ownerTypeId,
      vehicleId,
      transferStationId,
      vehicleNumber,
      Date,
    } = requestData;

    const queryParams = {
      VehicleTypeId,
      ZoneId,
      VehicleStatusId: VehicleStatusId,
      CollectionTypeId,
    };
    if (Date) queryParams.Date = Date;
    if (ownerTypeId) queryParams.ownerTypeId = ownerTypeId;
    if (vehicleId) queryParams.vehicleId = vehicleId;
    if (transferStationId) queryParams.transferStationId = transferStationId;
    if (vehicleNumber) queryParams.vehicleNumber = vehicleNumber;

    const queryString = new URLSearchParams(queryParams).toString();
    const response = await axiosInstance.get(
      API_BASE_URL3 +
        `SATInnerReport/SATDayDetailedCondemnedVechiles?${queryString}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    console.log("this is called");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const innergetUnderRepairVehicleReport = async (requestData) => {
  try {
    const {
      VehicleTypeId,
      VehicleStatusId,
      CollectionTypeId,
      ownerTypeId,
      vehicleId,
      transferStationId,
      vehicleNumber,
      ZoneId,
      Date,
    } = requestData;
    const queryParams = {
      VehicleTypeId,
      VehicleStatusId,
      CollectionTypeId,
    };
    if (Date) queryParams.Date = Date;
    if (ZoneId) queryParams.ZoneId = ZoneId;
    if (ownerTypeId) queryParams.ownerTypeId = ownerTypeId;
    if (vehicleId) queryParams.vehicleId = vehicleId;
    if (transferStationId) queryParams.transferStationId = transferStationId;
    if (vehicleNumber) queryParams.vehicleNumber = vehicleNumber;

    const queryString = new URLSearchParams(queryParams).toString();
    const response = await axiosInstance.get(
      API_BASE_URL3 +
        `SATInnerReport/SATDayDetailedUnderRepairVechiles?${queryString}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    console.log("this is called");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const innergetCondemnedVehicleReportAllZones = async (requestData) => {
  try {
    const {
      VehicleTypeId,
      VehicleStatusId,
      CollectionTypeId,
      ownerTypeId,
      vehicleId,
      transferStationId,
      vehicleNumber,
      Date,
    } = requestData;
    const queryParams = {
      VehicleTypeId,
      VehicleStatusId,
      CollectionTypeId,
    };

    if (Date) queryParams.Date = Date;
    if (ownerTypeId) queryParams.ownerTypeId = ownerTypeId;
    if (vehicleId) queryParams.vehicleId = vehicleId;
    if (transferStationId) queryParams.transferStationId = transferStationId;
    if (vehicleNumber) queryParams.vehicleNumber = vehicleNumber;

    const queryString = new URLSearchParams(queryParams).toString();
    const response = await axiosInstance.get(
      API_BASE_URL3 +
        `SATInnerReport/SATDayDetailedCondemnedVechiles?${queryString}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const innergetZonesVehicleReport = async (requestData) => {
  try {
    const { VehicleTypeId, VehicleStatusId } = requestData;
    const response = await axiosInstance.get(
      API_BASE_URL3 +
        `SATInnerReport/GetAllVehicleDetailsByFilters?vehicleTypeId=${VehicleTypeId}&VehicleStatusId=${VehicleStatusId}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const innergetVehicleReportAllZones = async (requestData) => {
  try {
    const { VehicleTypeId, VehicleStatusId } = requestData;
    const response = await axiosInstance.get(
      API_BASE_URL3 +
        `SATInnerReport/GetAllVehicleDetailsByFilters?vehicleTypeId=${VehicleTypeId}&VehicleStatusId=${VehicleStatusId}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const innergetActiveReport = async (requestData) => {
  try {
    const { VehicleTypeId, Date, ZoneId, IsActive, CollectionTypeId } =
      requestData;
    const response = await axiosInstance.get(
      API_BASE_URL3 +
        `SATInnerReport/GetAllVehicleDetailsByFilters?vehicleTypeId=${VehicleTypeId}&date=${Date}&zoneId=${ZoneId}&IsActive=${IsActive}&CollectionTypeId=${CollectionTypeId}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const innergetActiveCircleReport = async (requestData) => {
  try {
    const {
      VehicleTypeId,
      CircleId,
      IsActive,
      CollectionTypeId,
      ownerTypeId,
      vehicleId,
      transferStationId,
      vehicleNumber,
      Date,
    } = requestData;
    const queryParams = {
      VehicleTypeId,
      CircleId,
      IsActive,
      CollectionTypeId,
    };
    if (Date) queryParams.Date = Date;
    if (ownerTypeId) queryParams.ownerTypeId = ownerTypeId;
    if (vehicleId) queryParams.vehicleId = vehicleId;
    if (transferStationId) queryParams.transferStationId = transferStationId;
    if (vehicleNumber) queryParams.vehicleNumber = vehicleNumber;

    const queryString = new URLSearchParams(queryParams).toString();
    const response = await axiosInstance.get(
      API_BASE_URL3 +
        //  `MasterDetails/GetAllVehicleDetailsByFilters?vehicleTypeId=${VehicleTypeId}&IsActive=${IsActive}&CollectionTypeId=${CollectionTypeId}`,
        `SATInnerReport/SATDayDetailedTotalActiveVechiles?${queryString}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const innergetActiveCircleReportTotal = async (requestData) => {
  try {
    const {
      VehicleTypeId,
      CircleId,
      IsActive,
      CollectionTypeId,
      ownerTypeId,
      vehicleId,
      transferStationId,
      vehicleNumber,
      Date,
    } = requestData;
    const queryParams = {
      VehicleTypeId,
      IsActive,
      CollectionTypeId,
    };

    if (Date) queryParams.Date = Date;
    if (CircleId !== undefined) queryParams.CircleId = CircleId;
    if (ownerTypeId) queryParams.ownerTypeId = ownerTypeId;
    if (vehicleId) queryParams.vehicleId = vehicleId;
    if (transferStationId) queryParams.transferStationId = transferStationId;
    if (vehicleNumber) queryParams.vehicleNumber = vehicleNumber;

    const queryString = new URLSearchParams(queryParams).toString();
    const response = await axiosInstance.get(
      API_BASE_URL3 +
        `SATInnerReport/SATDayDetailedTotalActiveVechiles?${queryString}`,
      // `MasterDetails/GetAllVehicleDetailsByFilters?vehicleTypeId=${VehicleTypeId}&CircleId=${CircleId}&IsActive=${IsActive}&CollectionTypeId=${CollectionTypeId}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const innergetCircleActiveReport = async (requestData) => {
  try {
    const {
      VehicleTypeId,
      ZoneId,
      IsActive,
      CollectionTypeId,
      ownerType,
      vehicleId,
      transferStationId,
      vehicleNumber,
      Date,
    } = requestData;

    const queryParams = {
      VehicleTypeId,
      ZoneId,
      IsActive,
      CollectionTypeId,
    };

    if (Date) queryParams.Date = Date;
    if (ownerType) queryParams.ownerType = ownerType;
    if (vehicleId) queryParams.vehicleId = vehicleId;
    if (transferStationId) queryParams.transferStationId = transferStationId;
    if (vehicleNumber) queryParams.vehicleNumber = vehicleNumber;

    const queryString = new URLSearchParams(queryParams).toString();

    const response = await axiosInstance.get(
      API_BASE_URL3 +
        `SATInnerReport/GetAllVehicleDetailsByFilters?${queryString}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const innergetZoneActiveReport = async (requestData) => {
  try {
    const {
      VehicleTypeId,
      ZoneId,
      IsActive,
      CollectionTypeId,
      ownerTypeId,
      vehicleId,
      transferStationId,
      vehicleNumber,
      Date,
    } = requestData;

    const queryParams = {
      VehicleTypeId,
      // ZoneId,
      IsActive,
      CollectionTypeId,
    };

    if (Date) queryParams.Date = Date;
    if (ZoneId) queryParams.ZoneId = ZoneId;
    if (ownerTypeId) queryParams.ownerTypeId = ownerTypeId;
    if (vehicleId) queryParams.vehicleId = vehicleId;
    if (transferStationId) queryParams.transferStationId = transferStationId;
    if (vehicleNumber) queryParams.vehicleNumber = vehicleNumber;

    const queryString = new URLSearchParams(queryParams).toString();

    const response = await axiosInstance.get(
      API_BASE_URL3 +
        `SATInnerReport/SATDayDetailedTotalActiveVechiles?${queryString}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const innergetTotalZoneActiveReport1 = async (requestData) => {
  try {
    const {
      VehicleTypeId,
      ZoneId,
      IsActive,
      CollectionTypeId,
      ownerTypeId,
      vehicleId,
      transferStationId,
      vehicleNumber,
      Date,
    } = requestData;

    const queryParams = {
      VehicleTypeId,
      // ZoneId,
      IsActive,
      CollectionTypeId,
    };

    if (Date) queryParams.Date = Date;
    if (ZoneId) queryParams.ZoneId = ZoneId;
    if (ownerTypeId) queryParams.ownerTypeId = ownerTypeId;
    if (vehicleId) queryParams.vehicleId = vehicleId;
    if (transferStationId) queryParams.transferStationId = transferStationId;
    if (vehicleNumber) queryParams.vehicleNumber = vehicleNumber;

    const queryString = new URLSearchParams(queryParams).toString();

    const response = await axiosInstance.get(
      API_BASE_URL3 +
        `SATInnerReport/SATDayDetailedTotalActiveVechiles?${queryString}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const innergetTotalZoneActiveReport = async (requestData) => {
  try {
    const { VehicleTypeId, IsActive, CollectionTypeId } = requestData;
    const response = await axiosInstance.get(
      API_BASE_URL3 +
        `SATInnerReport/SATDayDetailedTotalActiveVechiles?vehicleTypeId=${VehicleTypeId}&IsActive=${IsActive}&CollectionTypeId=${CollectionTypeId}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const innergetZoneInActiveReport = async (requestData) => {
  try {
    const {
      VehicleTypeId,
      ZoneId,
      IsActive,
      CollectionTypeId,
      ownerTypeId,
      vehicleId,
      transferStationId,
      vehicleNumber,
      Date,
    } = requestData;

    const queryParams = {
      VehicleTypeId,
      ZoneId,
      IsActive,
      CollectionTypeId,
    };
    if (Date) queryParams.Date = Date;
    if (ownerTypeId) queryParams.ownerTypeId = ownerTypeId;
    if (vehicleId) queryParams.vehicleId = vehicleId;
    if (transferStationId) queryParams.transferStationId = transferStationId;
    if (vehicleNumber) queryParams.vehicleNumber = vehicleNumber;

    const queryString = new URLSearchParams(queryParams).toString();

    const response = await axiosInstance.get(
      API_BASE_URL3 +
        `SATInnerReport/SATDayDetailedTotalInactiveVechiles?${queryString}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const innergetZoneTotalInActiveReport = async (requestData) => {
  try {
    const {
      VehicleTypeId,
      IsActive,
      CollectionTypeId,
      ownerTypeId,
      vehicleId,
      transferStationId,
      vehicleNumber,
      Date,
    } = requestData;
    const queryParams = {
      VehicleTypeId,
      IsActive,
      CollectionTypeId,
    };
    if (Date) queryParams.Date = Date;
    if (ownerTypeId) queryParams.ownerTypeId = ownerTypeId;
    if (vehicleId) queryParams.vehicleId = vehicleId;
    if (transferStationId) queryParams.transferStationId = transferStationId;
    if (vehicleNumber) queryParams.vehicleNumber = vehicleNumber;

    const queryString = new URLSearchParams(queryParams).toString();
    const response = await axiosInstance.get(
      API_BASE_URL3 +
        `SATInnerReport/SATDayDetailedTotalInactiveVechiles?${queryString}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const innergetCircleInActiveReport = async (requestData) => {
  try {
    const {
      VehicleTypeId,
      CircleId,
      IsActive,
      CollectionTypeId,
      ownerTypeId,
      vehicleId,
      transferStationId,
      vehicleNumber,
      Date,
    } = requestData;
    const queryParams = {
      VehicleTypeId,
      CircleId,
      IsActive,
      CollectionTypeId,
    };
    if (Date) queryParams.Date = Date;
    if (ownerTypeId) queryParams.ownerTypeId = ownerTypeId;
    if (vehicleId) queryParams.vehicleId = vehicleId;
    if (transferStationId) queryParams.transferStationId = transferStationId;
    if (vehicleNumber) queryParams.vehicleNumber = vehicleNumber;

    const queryString = new URLSearchParams(queryParams).toString();
    const response = await axiosInstance.get(
      API_BASE_URL3 +
        //   `MasterDetails/GetAllVehicleDetailsByFilters?vehicleTypeId=${VehicleTypeId}&IsActive=${IsActive}&CollectionTypeId=${CollectionTypeId}`,
        `SATInnerReport/SATDayDetailedTotalInactiveVechiles?${queryString}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const innergetCircleInActiveReportTotal = async (requestData) => {
  try {
    const {
      VehicleTypeId,
      CircleId,
      IsActive,
      CollectionTypeId,
      ownerType,
      vehicleId,
      transferStationId,
      vehicleNumber,
      Date,
    } = requestData;
    const queryParams = {
      VehicleTypeId,
      // CircleId,
      IsActive,
      CollectionTypeId,
    };
    if (Date) queryParams.Date = Date;
    if (CircleId !== undefined) queryParams.CircleId = CircleId;
    if (ownerType) queryParams.ownerType = ownerType;
    if (vehicleId) queryParams.vehicleId = vehicleId;
    if (transferStationId) queryParams.transferStationId = transferStationId;
    if (vehicleNumber) queryParams.vehicleNumber = vehicleNumber;

    const queryString = new URLSearchParams(queryParams).toString();
    const response = await axiosInstance.get(
      API_BASE_URL3 +
        `SATInnerReport/SATDayDetailedTotalInactiveVechiles?${queryString}`,
      // `MasterDetails/GetAllVehicleDetailsByFilters?vehicleTypeId=${VehicleTypeId}&CircleId=${CircleId}&IsActive=${IsActive}&CollectionTypeId=${CollectionTypeId}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const innergetTotalReport = async (requestData) => {
  try {
    const {
      VehicleTypeId,
      ZoneId,
      CollectionTypeId,
      Date,
      ownerTypeId,
      vehicleId,
      transferStationId,
      vehicleNumber,
    } = requestData;

    const queryParams = {
      CollectionTypeId: CollectionTypeId,
      VehicleTypeId: VehicleTypeId,
    };

    if (ZoneId) queryParams.ZoneId = ZoneId;
    if (Date) queryParams.Date = Date;
    if (ownerTypeId) queryParams.ownerTypeId = ownerTypeId;
    if (vehicleId) queryParams.vehicleId = vehicleId;
    if (transferStationId) queryParams.transferStationId = transferStationId;
    if (vehicleNumber) queryParams.vehicleNumber = vehicleNumber;

    const queryString = new URLSearchParams(queryParams).toString();
    console.log("queryString param check", queryString);
    const response = await axiosInstance.get(
      API_BASE_URL3 +
        `SATInnerReport/SATDayDetailedTotalVechiles?${queryString}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const innergetTotalReportAllZones = async (requestData) => {
  try {
    const {
      VehicleTypeId,
      CollectionTypeId,
      Date,
      ownerTypeId,
      vehicleId,
      transferStationId,
      vehicleNumber,
    } = requestData;

    const queryParams = {
      CollectionTypeId: CollectionTypeId,
      VehicleTypeId: VehicleTypeId,
    };

    if (Date) queryParams.Date = Date;
    if (ownerTypeId) queryParams.ownerTypeId = ownerTypeId;
    if (vehicleId) queryParams.vehicleId = vehicleId;
    if (transferStationId) queryParams.transferStationId = transferStationId;
    if (vehicleNumber) queryParams.vehicleNumber = vehicleNumber;

    const queryString = new URLSearchParams(queryParams).toString();

    const response = await axiosInstance.get(
      API_BASE_URL3 +
        `SATInnerReport/SATDayDetailedTotalVechiles?${queryString}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
// export const innergetWardReport = async () => {
//   try {
//     const response = await axios.get(API_BASE_URL1 + `TransactionReport/GetAllTransferStationTransaction`,

//     );
//     return response.data;
//   } catch (error) {
//     throw error;

//   }
// };

export const innergetReportedAtWardWise = async (requestData) => {
  try {
    const {
      startDate,
      endDate,
      ZoneId,
      CollectionTypeId,
      allZones,
      VehicleTypeId,
      ownerTypeId,
      vehicleId,
      transferStationId,
      vehicleNumber,
      Date,
    } = requestData;

    const queryParams = {
      startDate,
      endDate,
      ZoneId,
      VehicleTypeId,
      CollectionTypeId,
    };
    // if (Date) queryParams.Date = Date;
    if (ownerTypeId) queryParams.ownerTypeId = ownerTypeId;
    if (vehicleId) queryParams.vehicleId = vehicleId;
    if (transferStationId) queryParams.transferStationId = transferStationId;
    if (vehicleNumber) queryParams.vehicleNumber = vehicleNumber;

    const queryString = new URLSearchParams(queryParams).toString();
    const response = await axiosInstance.get(
      API_BASE_URL3 +
        `SATInnerReport/GetAllPrimaryDeploymentTransaction?${queryString}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const innerTotalgetReportedAtWardWise = async (requestData) => {
  try {
    const {
      startDate,
      endDate,
      VehicleTypeId,
      CollectionTypeId,
      ownerTypeId,
      vehicleId,
      transferStationId,
      vehicleNumber,
      Date,
    } = requestData;
    const queryParams = {
      startDate,
      endDate,
      VehicleTypeId,
      CollectionTypeId,
    };
    // if (Date) queryParams.Date = Date;
    if (ownerTypeId) queryParams.ownerTypeId = ownerTypeId;
    if (vehicleId) queryParams.vehicleId = vehicleId;
    if (transferStationId) queryParams.transferStationId = transferStationId;
    if (vehicleNumber) queryParams.vehicleNumber = vehicleNumber;

    const queryString = new URLSearchParams(queryParams).toString();
    const response = await axiosInstance.get(
      API_BASE_URL3 +
        `SATInnerReport/GetAllPrimaryDeploymentTransaction?${queryString}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const innergetReportedAtWardAndTS = async (requestData) => {
  try {
    const {
      Date,
      ZoneId,
      VehicleTypeId,
      CollectionTypeId,
      ownerTypeId,
      vehicleId,
      transferStationId,
      vehicleNumber,
    } = requestData;

    const queryParams = {
      Date,
      ZoneId,
      VehicleTypeId,
      CollectionTypeId,
    };

    if (ownerTypeId) queryParams.ownerTypeId = ownerTypeId;
    if (vehicleId) queryParams.vehicleId = vehicleId;
    if (transferStationId) queryParams.transferStationId = transferStationId;
    if (vehicleNumber) queryParams.vehicleNumber = vehicleNumber;

    const queryString = new URLSearchParams(queryParams).toString();
    const response = await axiosInstance.get(
      API_BASE_URL3 +
        `SATInnerReport/GetPrimaryVehicleReportedAtWardAndTransferStation?${queryString}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const innerTotalgetReportedAtWardAndTS = async (requestData) => {
  try {
    const {
      Date,
      CollectionTypeId,
      VehicleTypeId,
      ownerTypeId,
      vehicleId,
      transferStationId,
      vehicleNumber,
    } = requestData;
    const queryParams = {
      Date,
      CollectionTypeId,
      VehicleTypeId,
    };

    if (ownerTypeId) queryParams.ownerTypeId = ownerTypeId;
    if (vehicleId) queryParams.vehicleId = vehicleId;
    if (transferStationId) queryParams.transferStationId = transferStationId;
    if (vehicleNumber) queryParams.vehicleNumber = vehicleNumber;

    const queryString = new URLSearchParams(queryParams).toString();
    const response = await axiosInstance.get(
      API_BASE_URL3 +
        `SATInnerReport/GetPrimaryVehicleReportedAtWardAndTransferStation?${queryString}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const innergetReportedAtWardAndTSCircle = async (requestData) => {
  try {
    const {
      Date,
      CircleId,
      VehicleTypeId,
      ownerTypeId,
      vehicleId,
      transferStationId,
      vehicleNumber,
    } = requestData;
    const queryParams = {
      Date,
      CircleId,
      VehicleTypeId,
    };

    if (ownerTypeId) queryParams.ownerTypeId = ownerTypeId;
    if (vehicleId) queryParams.vehicleId = vehicleId;
    if (transferStationId) queryParams.transferStationId = transferStationId;
    if (vehicleNumber) queryParams.vehicleNumber = vehicleNumber;

    const queryString = new URLSearchParams(queryParams).toString();
    const response = await axiosInstance.get(
      API_BASE_URL3 +
        // `SATInnerReport/GetPrimaryVehicleReportedAtWardAndTransferStation?date=${Date}&vehicleTypeId=${VehicleTypeId}`,
        `SATInnerReport/GetPrimaryVehicleReportedAtWardAndTransferStation?${queryString}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const innergetReportedAtWardAndTSCircleTotal = async (requestData) => {
  try {
    const {
      Date,
      CircleId,
      VehicleTypeId,
      ownerTypeId,
      vehicleId,
      transferStationId,
      vehicleNumber,
    } = requestData;
    const queryParams = {
      Date,
      // CircleId,
      VehicleTypeId,
    };
    if (CircleId !== undefined) queryParams.CircleId = CircleId;
    if (ownerTypeId) queryParams.ownerTypeId = ownerTypeId;
    if (vehicleId) queryParams.vehicleId = vehicleId;
    if (transferStationId) queryParams.transferStationId = transferStationId;
    if (vehicleNumber) queryParams.vehicleNumber = vehicleNumber;

    const queryString = new URLSearchParams(queryParams).toString();
    const response = await axiosInstance.get(
      API_BASE_URL3 +
        `SATInnerReport/GetPrimaryVehicleReportedAtWardAndTransferStation?${queryString}`,
      // `SATInnerReport/GetPrimaryVehicleReportedAtWardAndTransferStation?Date=${Date}&CircleId=${CircleId}&vehicleTypeId=${VehicleTypeId}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const innergetNotReportedAtWard = async (requestData) => {
  try {
    const {
      Date,
      ZoneId,
      VehicleTypeId,
      CollectionTypeId,
      ownerTypeId,
      vehicleId,
      transferStationId,
      vehicleNumber,
    } = requestData;

    const queryParams = {
      Date,
      ZoneId,
      VehicleTypeId,
      CollectionTypeId,
    };

    if (ownerTypeId) queryParams.ownerTypeId = ownerTypeId;
    if (vehicleId) queryParams.vehicleId = vehicleId;
    if (transferStationId) queryParams.transferStationId = transferStationId;
    if (vehicleNumber) queryParams.vehicleNumber = vehicleNumber;

    const queryString = new URLSearchParams(queryParams).toString();
    const response = await axiosInstance.get(
      API_BASE_URL3 +
        `SATInnerReport/GetPrimaryVehicleNotReportedAtWard?${queryString}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const innerTotalgetNotReportedAtWard1 = async (requestData) => {
  try {
    const {
      Date,
      VehicleTypeId,
      CollectionTypeId,
      ownerTypeId,
      vehicleId,
      transferStationId,
      vehicleNumber,
    } = requestData;

    const queryParams = {
      Date,
      VehicleTypeId,
      CollectionTypeId,
    };

    if (ownerTypeId) queryParams.ownerTypeId = ownerTypeId;
    if (vehicleId) queryParams.vehicleId = vehicleId;
    if (transferStationId) queryParams.transferStationId = transferStationId;
    if (vehicleNumber) queryParams.vehicleNumber = vehicleNumber;

    const queryString = new URLSearchParams(queryParams).toString();
    const response = await axiosInstance.get(
      API_BASE_URL3 +
        `SATInnerReport/GetPrimaryVehicleNotReportedAtWard?${queryString}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const innerTotalgetNotReportedAtWard = async (requestData) => {
  try {
    const { Date, VehicleTypeId, CollectionTypeId } = requestData;
    const response = await axiosInstance.get(
      API_BASE_URL3 +
        `SATInnerReport/GetPrimaryVehicleNotReportedAtWard?Date=${Date}&vehicleTypeId=${VehicleTypeId}&CollectionTypeId=${CollectionTypeId}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const innergetNotReportedAtWardCircle = async (requestData) => {
  try {
    const {
      Date,
      CircleId,
      VehicleTypeId,
      ownerTypeId,
      vehicleId,
      transferStationId,
      vehicleNumber,
    } = requestData;
    const queryParams = {
      Date,
      CircleId,
      VehicleTypeId,
    };

    if (ownerTypeId) queryParams.ownerTypeId = ownerTypeId;
    if (vehicleId) queryParams.vehicleId = vehicleId;
    if (transferStationId) queryParams.transferStationId = transferStationId;
    if (vehicleNumber) queryParams.vehicleNumber = vehicleNumber;

    const queryString = new URLSearchParams(queryParams).toString();
    const response = await axiosInstance.get(
      API_BASE_URL3 +
        // `SATInnerReport/GetPrimaryVehicleNotReportedAtWard?Date=${Date}&vehicleTypeId=${VehicleTypeId}`,
        `SATInnerReport/GetPrimaryVehicleNotReportedAtWard?${queryString}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const innergetNotReportedAtWardCircleTotal = async (requestData) => {
  try {
    const {
      Date,
      VehicleTypeId,
      ownerTypeId,
      vehicleId,
      transferStationId,
      vehicleNumber,
    } = requestData;
    const queryParams = {
      Date,
      VehicleTypeId,
    };

    if (ownerTypeId) queryParams.ownerTypeId = ownerTypeId;
    if (vehicleId) queryParams.vehicleId = vehicleId;
    if (transferStationId) queryParams.transferStationId = transferStationId;
    if (vehicleNumber) queryParams.vehicleNumber = vehicleNumber;

    const queryString = new URLSearchParams(queryParams).toString();
    const response = await axiosInstance.get(
      API_BASE_URL3 +
        `SATInnerReport/GetPrimaryVehicleNotReportedAtWard?${queryString}`,
      // `SATInnerReport/GetPrimaryVehicleNotReportedAtWard?Date=${Date}&CircleId=${CircleId}&vehicleTypeId=${VehicleTypeId}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const innergetReportedAtWardNotTS = async (requestData) => {
  try {
    const {
      Date,
      ZoneId,
      VehicleTypeId,
      ownerTypeId,
      vehicleId,
      transferStationId,
      vehicleNumber,
    } = requestData;

    const queryParams = {
      Date,
      ZoneId,
      VehicleTypeId,
    };

    if (ownerTypeId) queryParams.ownerTypeId = ownerTypeId;
    if (vehicleId) queryParams.vehicleId = vehicleId;
    if (transferStationId) queryParams.transferStationId = transferStationId;
    if (vehicleNumber) queryParams.vehicleNumber = vehicleNumber;

    const queryString = new URLSearchParams(queryParams).toString();
    const response = await axiosInstance.get(
      API_BASE_URL3 +
        `SATInnerReport/GetPrimaryVehicleReportedAtWardButNotInTransferStation?${queryString}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const innerTotalgetReportedAtWardNotTS = async (requestData) => {
  try {
    const {
      Date,
      VehicleTypeId,
      ownerTypeId,
      vehicleId,
      transferStationId,
      vehicleNumber,
    } = requestData;
    const queryParams = {
      Date,
      VehicleTypeId,
    };

    if (ownerTypeId) queryParams.ownerTypeId = ownerTypeId;
    if (vehicleId) queryParams.vehicleId = vehicleId;
    if (transferStationId) queryParams.transferStationId = transferStationId;
    if (vehicleNumber) queryParams.vehicleNumber = vehicleNumber;

    const queryString = new URLSearchParams(queryParams).toString();
    const response = await axiosInstance.get(
      API_BASE_URL3 +
        `SATInnerReport/GetPrimaryVehicleReportedAtWardButNotInTransferStation?${queryString}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const innergetReportedAtWardNotTSCircle = async (requestData) => {
  try {
    const {
      Date,
      CircleId,
      VehicleTypeId,
      ownerTypeId,
      vehicleId,
      transferStationId,
      vehicleNumber,
    } = requestData;
    const queryParams = {
      Date,
      CircleId,
      VehicleTypeId,
    };

    if (ownerTypeId) queryParams.ownerTypeId = ownerTypeId;
    if (vehicleId) queryParams.vehicleId = vehicleId;
    if (transferStationId) queryParams.transferStationId = transferStationId;
    if (vehicleNumber) queryParams.vehicleNumber = vehicleNumber;

    const queryString = new URLSearchParams(queryParams).toString();
    const response = await axiosInstance.get(
      API_BASE_URL3 +
        //  `SATInnerReport/GetPrimaryVehicleReportedAtWardButNotInTransferStation?date=${Date}&vehicleTypeId=${VehicleTypeId}`,
        `SATInnerReport/GetPrimaryVehicleReportedAtWardButNotInTransferStation?${queryString}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};
export const innergetReportedAtWardNotTSCircleTotal = async (requestData) => {
  try {
    const {
      Date,
      CircleId,
      VehicleTypeId,
      ownerTypeId,
      vehicleId,
      transferStationId,
      vehicleNumber,
    } = requestData;
    const queryParams = {
      Date,
      // CircleId,
      VehicleTypeId,
    };
    if (CircleId !== undefined) queryParams.CircleId = CircleId;
    if (ownerTypeId) queryParams.ownerTypeId = ownerTypeId;
    if (vehicleId) queryParams.vehicleId = vehicleId;
    if (transferStationId) queryParams.transferStationId = transferStationId;
    if (vehicleNumber) queryParams.vehicleNumber = vehicleNumber;

    const queryString = new URLSearchParams(queryParams).toString();
    const response = await axiosInstance.get(
      API_BASE_URL3 +
        `SATInnerReport/GetPrimaryVehicleReportedAtWardButNotInTransferStation?${queryString}`,
      // `SATInnerReport/GetPrimaryVehicleReportedAtWardButNotInTransferStation?Date=${Date}&CircleId=${CircleId}&vehicleTypeId=${VehicleTypeId}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};
export const innergetReportedAtWardCircleWise = async (requestData) => {
  try {
    const {
      VehicleTypeId,
      CircleId,
      startDate,
      endDate,
      ownerTypeId,
      vehicleId,
      transferStationId,
      vehicleNumber,
    } = requestData;
    const queryParams = {
      VehicleTypeId,
      CircleId,
      startDate,
      endDate,
    };

    if (ownerTypeId) queryParams.ownerTypeId = ownerTypeId;
    if (vehicleId) queryParams.vehicleId = vehicleId;
    if (transferStationId) queryParams.transferStationId = transferStationId;
    if (vehicleNumber) queryParams.vehicleNumber = vehicleNumber;

    const queryString = new URLSearchParams(queryParams).toString();
    const response = await axiosInstance.get(
      API_BASE_URL3 +
        // `SATInnerReport/GetAllPrimaryDeploymentTransaction?startDate=${startDate}&endDate=${endDate}&vehicleTypeId=${VehicleTypeId}`,
        `SATInnerReport/GetAllPrimaryDeploymentTransaction?${queryString}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const innergetReportedAtWardCircleWiseTotal = async (requestData) => {
  try {
    const {
      VehicleTypeId,
      CircleId,
      startDate,
      endDate,
      ownerTypeId,
      vehicleId,
      transferStationId,
      vehicleNumber,
    } = requestData;
    const queryParams = {
      VehicleTypeId,
      // CircleId,
      startDate,
      endDate,
    };

    if (CircleId !== undefined) queryParams.CircleId = CircleId;
    if (ownerTypeId) queryParams.ownerTypeId = ownerTypeId;
    if (vehicleId) queryParams.vehicleId = vehicleId;
    if (transferStationId) queryParams.transferStationId = transferStationId;
    if (vehicleNumber) queryParams.vehicleNumber = vehicleNumber;

    const queryString = new URLSearchParams(queryParams).toString();
    const response = await axiosInstance.get(
      API_BASE_URL3 +
        `SATInnerReport/GetAllPrimaryDeploymentTransaction?${queryString}`,
      // `SATInnerReport/GetAllPrimaryDeploymentTransaction?startDate=${startDate}&endDate=${endDate}&vehicleTypeId=${VehicleTypeId}&CircleId=${CircleId}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const innergetTotalReportCircleWise = async (requestData) => {
  try {
    const {
      VehicleTypeId,
      CircleId,
      CollectionTypeId,
      ownerTypeId,
      vehicleId,
      transferStationId,
      vehicleNumber,
      Date
    } = requestData;

    const queryParams = {
      CircleId,
      VehicleTypeId,
      CollectionTypeId,
    };
if (Date) queryParams.Date = Date;
    if (ownerTypeId) queryParams.ownerTypeId = ownerTypeId;
    if (vehicleId) queryParams.vehicleId = vehicleId;
    if (transferStationId) queryParams.transferStationId = transferStationId;
    if (vehicleNumber) queryParams.vehicleNumber = vehicleNumber;

    const queryString = new URLSearchParams(queryParams).toString();
    //const response = await axios.get(API_BASE_URL1 + `MasterDetails/GetAllVehicleDetailsByFilters?vehicleTypeId=${VehicleTypeId}&CollectionTypeId=${CollectionTypeId}`,
    const response = await axiosInstance.get(
      API_BASE_URL3 +
        `SATInnerReport/SATDayDetailedTotalVechiles?${queryString}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const innergetTotalReportCircleWiseCircle = async (requestData) => {
  try {
    const {
      VehicleTypeId,
      CircleId,
      CollectionTypeId,
      ownerTypeId,
      vehicleId,
      transferStationId,
      vehicleNumber,
      Date
    } = requestData;
    const queryParams = {
      VehicleTypeId,
      // CircleId,
      CollectionTypeId,
    };
if (Date) queryParams.Date = Date;
    if (CircleId) queryParams.CircleId = CircleId;
    if (ownerTypeId) queryParams.ownerTypeId = ownerTypeId;
    if (vehicleId) queryParams.vehicleId = vehicleId;
    if (transferStationId) queryParams.transferStationId = transferStationId;
    if (vehicleNumber) queryParams.vehicleNumber = vehicleNumber;

    const queryString = new URLSearchParams(queryParams).toString();
    const response = await axiosInstance.get(
      API_BASE_URL3 +
        `SATInnerReport/SATDayDetailedTotalVechiles?${queryString}`,
      // const response = await axios.get(API_BASE_URL1 + `MasterDetails/GetAllVehicleDetailsByFilters?vehicleTypeId=${VehicleTypeId}&CircleId=${CircleId}&CollectionTypeId=${CollectionTypeId}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const innergetCondemnedReportCircleWise = async (requestData) => {
  try {
    const {
      VehicleTypeId = null,
      CircleId,
      VehicleStatusId,
      CollectionTypeId,
      ownerTypeId,
      vehicleId,
      transferStationId,
      vehicleNumber,
      Date
    } = requestData;
    const queryParams = {
      VehicleTypeId,
      CircleId,
      VehicleStatusId,
      CollectionTypeId,
    };
if (Date) queryParams.Date = Date;
    if (ownerTypeId) queryParams.ownerTypeId = ownerTypeId;
    if (vehicleId) queryParams.vehicleId = vehicleId;
    if (transferStationId) queryParams.transferStationId = transferStationId;
    if (vehicleNumber) queryParams.vehicleNumber = vehicleNumber;

    const queryString = new URLSearchParams(queryParams).toString();

    const response = await axiosInstance.get(
      API_BASE_URL3 +
        //`MasterDetails/GetAllVehicleDetailsByFilters?vehicleTypeId=${VehicleTypeId}&VehicleStatusId=${VehicleStatusId}`,
        `SATInnerReport/SATDayDetailedCondemnedVechiles?${queryString}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const innergetCondemnedReportCircleWiseCircle = async (requestData) => {
  try {
    const {
      VehicleTypeId,
      CircleId,
      VehicleStatusId,
      CollectionTypeId,
      ownerTypeId,
      vehicleId,
      transferStationId,
      vehicleNumber,
      Date
    } = requestData;
    const queryParams = {
      VehicleTypeId,
      // CircleId,
      VehicleStatusId,
      CollectionTypeId,
    };
if (Date) queryParams.Date = Date;
    if (CircleId !== undefined) queryParams.CircleId = CircleId;
    if (ownerTypeId) queryParams.ownerTypeId = ownerTypeId;
    if (vehicleId) queryParams.vehicleId = vehicleId;
    if (transferStationId) queryParams.transferStationId = transferStationId;
    if (vehicleNumber) queryParams.vehicleNumber = vehicleNumber;

    const queryString = new URLSearchParams(queryParams).toString();
    const response = await axiosInstance.get(
      API_BASE_URL3 +
        `SATInnerReport/SATDayDetailedCondemnedVechiles?${queryString}`,
      //  `MasterDetails/GetAllVehicleDetailsByFilters?vehicleTypeId=${VehicleTypeId}&CircleId=${CircleId}&VehicleStatusId=${VehicleStatusId}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const innergetUnderRepairReportCircleWise = async (requestData) => {
  try {
    const {
      VehicleTypeId,
      CircleId,
      VehicleStatusId,
      ownerTypeId,
      vehicleId,
      transferStationId,
      vehicleNumber,
      Date,
    } = requestData;
    const queryParams = {
      VehicleTypeId,
      CircleId,
      VehicleStatusId,
    };
    if (Date) queryParams.Date = Date;
    if (ownerTypeId) queryParams.ownerTypeId = ownerTypeId;
    if (vehicleId) queryParams.vehicleId = vehicleId;
    if (transferStationId) queryParams.transferStationId = transferStationId;
    if (vehicleNumber) queryParams.vehicleNumber = vehicleNumber;

    const queryString = new URLSearchParams(queryParams).toString();
    const response = await axiosInstance.get(
      API_BASE_URL3 +
        // `MasterDetails/GetAllVehicleDetailsByFilters?vehicleTypeId=${VehicleTypeId}&VehicleStatusId=${VehicleStatusId}`,
        `SATInnerReport/SATDayDetailedUnderRepairVechiles?${queryString}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const innergetUnderRepairReportCircleWiseTotal = async (requestData) => {
  try {
    const {
      VehicleTypeId,
      CircleId,
      VehicleStatusId,
      ownerTypeId,
      vehicleId,
      transferStationId,
      vehicleNumber,
      Date,
    } = requestData;
    const queryParams = {
      VehicleTypeId,
      VehicleStatusId,
    };
    if (Date) queryParams.Date = Date;
    if (CircleId !== undefined) queryParams.CircleId = CircleId;
    if (ownerTypeId) queryParams.ownerTypeId = ownerTypeId;
    if (vehicleId) queryParams.vehicleId = vehicleId;
    if (transferStationId) queryParams.transferStationId = transferStationId;
    if (vehicleNumber) queryParams.vehicleNumber = vehicleNumber;

    const queryString = new URLSearchParams(queryParams).toString();
    const response = await axiosInstance.get(
      API_BASE_URL3 +
        `SATInnerReport/SATDayDetailedUnderRepairVechiles?${queryString}`,
      //  `MasterDetails/GetAllVehicleDetailsByFilters?vehicleTypeId=${VehicleTypeId}&CircleId=${CircleId}&VehicleStatusId=${VehicleStatusId}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const innergetReportedTsNotWardReportZoneWise = async (requestData) => {
  try {
    const { VehicleTypeId, zoneId, date, CollectionTypeId ,ownerTypeId ,vehicleNumber ,transferStationId} = requestData;
    const queryParams = {
      VehicleTypeId,
      zoneId,
      date,
      CollectionTypeId,
    };
    if (ownerTypeId) queryParams.ownerTypeId = ownerTypeId;
    if (vehicleNumber) queryParams.vehicleNumber = vehicleNumber;
    if (transferStationId) queryParams.transferStationId = transferStationId;

    const queryString = new URLSearchParams(queryParams).toString();
    const response = await axiosInstance.get(
      API_BASE_URL3 +
      `SATInnerReport/GetPrimaryVehicleReportedAtTransferStationButNotInWard?${queryString}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const innerTotalgetReportedTsNotWardReportZoneWise = async (
  requestData
) => {
  try {
    const {
      vehicleTypeId,
      date,
      CollectionTypeId,
      ownerType,
      vehicleId,
      transferStationId,
      vehicleNumber,
    } = requestData;
    const queryParams = {
      vehicleTypeId,
      date,
      CollectionTypeId,
    };

    if (ownerType) queryParams.ownerType = ownerType;
    if (vehicleId) queryParams.vehicleId = vehicleId;
    if (transferStationId) queryParams.transferStationId = transferStationId;
    if (vehicleNumber) queryParams.vehicleNumber = vehicleNumber;

    const queryString = new URLSearchParams(queryParams).toString();
    const response = await axiosInstance.get(
      API_BASE_URL3 +
        `SATInnerReport/GetPrimaryVehicleReportedAtTransferStationButNotInWard?${queryString}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const innergetReportedTsNotWardReportCircleWise = async (
  requestData
) => {
  try {
    const {
      vehicleTypeId,
      CircleId,
      date,
      ownerTypeId,
      vehicleId,
      transferStationId,
      vehicleNumber,
    } = requestData;
    const queryParams = {
      vehicleTypeId,
      CircleId,
      date,
    };

    if (ownerTypeId) queryParams.ownerTypeId = ownerTypeId;
    if (vehicleId) queryParams.vehicleId = vehicleId;
    if (transferStationId) queryParams.transferStationId = transferStationId;
    if (vehicleNumber) queryParams.vehicleNumber = vehicleNumber;

    const queryString = new URLSearchParams(queryParams).toString();
    const response = await axiosInstance.get(
      API_BASE_URL3 +
        // `SATInnerReport/GetPrimaryVehicleReportedAtTransferStationButNotInWard?date=${Date}&vehicleTypeId=${VehicleTypeId}`,
        `SATInnerReport/GetPrimaryVehicleReportedAtTransferStationButNotInWard?${queryString}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const innergetReportedTsNotWardReportCircleWiseTotal = async (
  requestData
) => {
  try {
    const {
      vehicleTypeId,
      CircleId,
      date,
      ownerTypeId,
      vehicleId,
      transferStationId,
      vehicleNumber,
    } = requestData;
    const queryParams = {
      vehicleTypeId,
      // CircleId,
      date,
    };

    if (CircleId !== undefined) queryParams.CircleId = CircleId;
    if (ownerTypeId) queryParams.ownerTypeId = ownerTypeId;
    if (vehicleId) queryParams.vehicleId = vehicleId;
    if (transferStationId) queryParams.transferStationId = transferStationId;
    if (vehicleNumber) queryParams.vehicleNumber = vehicleNumber;

    const queryString = new URLSearchParams(queryParams).toString();
    const response = await axiosInstance.get(
      API_BASE_URL3 +
        `SATInnerReport/GetPrimaryVehicleReportedAtTransferStationButNotInWard?${queryString}`,
      //  `SATInnerReport/GetPrimaryVehicleReportedAtTransferStationButNotInWard?date=${Date}&circleId=${CircleId}&vehicleTypeId=${VehicleTypeId}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
